<div
    *transloco="let t"
    class="tms-symbol-control bazis-control"
>
    @let required = required$ | async;
    @let valueChanges = valueChanges$ | async;
    <bazis-label
        [isMajor]="hasTitleMajor"
        [isEmptyLabel]="isEmptyLabel"
        [title]="title || t(titleKey, titleParams)"
        [required]="required"
    >
        @if (tooltipKey) {
            <bazis-interrogation
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
            ></bazis-interrogation>
        }
    </bazis-label>

    <div class="bh-flex bh-align-items-center">
        <bazis-control-field-start
            [tooltipText]="t(tooltipKey, tooltipParams)"
            [tooltipSettings]="tooltipSettings"
        >
        </bazis-control-field-start>
        @if (fields.controls?.length > 0) {
            <div
                #group
                class="bazis-control__field-group-wrapper"
            >
                @for (field of fields.controls; track $index; let i = $index) {
                    <span
                        class="bazis-control__field-group"
                        [class.bazis-control__field-group--disabled]="fields.disabled"
                        [class.bazis-control__field-group--focused]="isFocused"
                    >
                        <input
                            [type]="type"
                            class="bazis-control__field"
                            (input)="onInput(i)"
                            (keyup.backspace)="onBackspace(i)"
                            [placeholder]="placeholder ? placeholder : t(placeholderKey)"
                            (focus)="onFocus(i)"
                            [formControl]="field"
                        />
                    </span>
                }
            </div>
        }
        <bazis-control-field-end
            [tooltipText]="t(tooltipKey, tooltipParams)"
            [tooltipSettings]="tooltipSettings"
        >
        </bazis-control-field-end>
    </div>

    <div class="bazis-control__error">
        <bazis-form-error
            [validationErrorMessages]="validationErrorMessages"
            [formControl]="ngControl.control"
        ></bazis-form-error>

        <!-- для ошибок родительского контрола
            (пример использоавния в input-text-array, предполагается сюда "вложить" bazis-form-error) -->
        <ng-content></ng-content>
    </div>

    @if (noteKey) {
        <div class="bazis-control__note">
            {{ t(noteKey, noteParams) }}
        </div>
    }
</div>
